import { ComponentPortal } from '@angular/cdk/portal';
import * as i0 from '@angular/core';
import { input, signal, Component, ViewEncapsulation, Inject, computed, effect, untracked, Injector, TemplateRef, Directive } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NgTemplateOutlet, NgClass } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import * as i1 from '@angular/cdk/overlay';
const _c0 = a0 => ({
  "ngx-tooltip-width-fit-content": a0
});
const _c1 = a0 => ({
  translate: a0
});
const _c2 = (a0, a1) => ({
  value: a0,
  params: a1
});
function NgxTooltipComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 4);
    i0.ɵɵelement(2, "path", 5);
    i0.ɵɵelementEnd()();
  }
}
function NgxTooltipComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NgxTooltipComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate(ctx_r0.text());
  }
}
const NgxTooltipToken = Symbol('NgxTooltip');
let NgxTooltipComponent = /*#__PURE__*/(() => {
  class NgxTooltipComponent {
    constructor(ngxTooltip) {
      this.text = input();
      this.template = input();
      this.fitContent = input(false);
      this.disableArrow = input(false);
      this.animationPosition = signal('tooltip-position-top');
      this.positions = signal({
        'tooltip-position-left': 'translateX(-16px)',
        'tooltip-position-right': 'translateX(16px)',
        'tooltip-position-top': 'translateY(-16px)',
        'tooltip-position-bottom': 'translateY(-16px)',
        'tooltip-position-top-right': 'translateY(-16px)',
        'tooltip-position-top-left': 'translateY(-16px)',
        'tooltip-position-bottom-right': 'translateY(-16px)',
        'tooltip-position-bottom-left': 'translateY(-16px)'
      });
      this.animationState = signal('visible');
      this.animationPosition.set(ngxTooltip.panelClass);
    }
    static {
      this.ɵfac = function NgxTooltipComponent_Factory(t) {
        return new (t || NgxTooltipComponent)(i0.ɵɵdirectiveInject(NgxTooltipToken));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxTooltipComponent,
        selectors: [["ngx-tooltip"]],
        inputs: {
          text: [i0.ɵɵInputFlags.SignalBased, "text"],
          template: [i0.ɵɵInputFlags.SignalBased, "template"],
          fitContent: [i0.ɵɵInputFlags.SignalBased, "fitContent"],
          disableArrow: [i0.ɵɵInputFlags.SignalBased, "disableArrow"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 5,
        vars: 11,
        consts: [["noTemplate", ""], [1, "ngx-tooltip", "surface-glass-high-contrast-invert", "text-oninvert-high", 3, "ngClass"], [1, "ngx-tooltip__arrow"], [4, "ngTemplateOutlet"], ["xmlns", "http://www.w3.org/2000/svg", "width", "16", "height", "7", "viewBox", "0 0 16 7", "fill", "none"], ["d", "M14.717 7H0.28301C1.66217 7 2.94405 6.28952 3.675 5.12L5.804 1.71359C6.58734 0.460258 8.41266 0.460258 9.196 1.71359L11.325 5.12C12.056 6.28952 13.3378 7 14.717 7Z"]],
        template: function NgxTooltipComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, NgxTooltipComponent_Conditional_1_Template, 3, 0, "div", 2)(2, NgxTooltipComponent_ng_container_2_Template, 1, 0, "ng-container", 3)(3, NgxTooltipComponent_ng_template_3_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const noTemplate_r2 = i0.ɵɵreference(4);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, ctx.fitContent()))("@ngxTooltip", i0.ɵɵpureFunction2(8, _c2, ctx.animationState(), i0.ɵɵpureFunction1(6, _c1, ctx.positions()[ctx.animationPosition()])));
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, !ctx.disableArrow() ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.template() || noTemplate_r2);
          }
        },
        dependencies: [NgTemplateOutlet, NgClass],
        styles: [".tooltip-position-top .ngx-tooltip__arrow{bottom:0;margin-bottom:-12px;left:calc(50% - 9px);transform:rotate(180deg)}.tooltip-position-bottom .ngx-tooltip__arrow{top:0;margin-top:-12px;left:calc(50% - 9px);transform:rotate(0)}.tooltip-position-left .ngx-tooltip__arrow{right:0;margin-right:-10px;top:calc(50% - 9px);transform:rotate(90deg);width:auto;height:auto}.tooltip-position-right .ngx-tooltip__arrow{left:0;margin-left:-10px;top:calc(50% - 9px);transform:rotate(270deg);width:auto;height:auto}.tooltip-position-top-right .ngx-tooltip__arrow{bottom:0;margin-bottom:-12px;left:12px;transform:rotate(180deg)}.tooltip-position-top-left .ngx-tooltip__arrow{bottom:0;margin-bottom:-12px;right:12px;transform:rotate(180deg)}.tooltip-position-bottom-right .ngx-tooltip__arrow{top:0;margin-top:-12px;left:12px;transform:rotate(0)}.tooltip-position-bottom-left .ngx-tooltip__arrow{top:0;margin-top:-12px;right:12px;transform:rotate(0)}.ngx-tooltip{margin:7px;min-width:48px;max-width:256px;max-height:92px;border-radius:8px;text-align:right;pointer-events:none;position:relative;padding:6px 10px 8px;font-size:12px;line-height:20px}.ngx-tooltip-width-fit-content{max-width:fit-content}.ngx-tooltip__arrow{position:absolute;width:16px;height:7px}.ngx-tooltip__arrow svg path{fill:var(--surface-glass-high-contrast-invert)}\n"],
        encapsulation: 2,
        data: {
          animation: [trigger('ngxTooltip', [state('initial, void, hidden', style({
            opacity: 0,
            transform: `{{translate}}`
          }), {
            params: {
              translate: `{{translate}}`
            }
          }), state('visible', style({
            transform: 'translate(0)'
          })), transition('* => visible', animate('150ms cubic-bezier(0, 0, 0.2, 1)')), transition('* => hidden', animate('75ms cubic-bezier(0.4, 0, 1, 1)'))])]
        }
      });
    }
  }
  return NgxTooltipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxTooltipDirective = /*#__PURE__*/(() => {
  class NgxTooltipDirective {
    #withConditionTimeOut;
    #overlayRef;
    #destroyed;
    #tooltipRef;
    #positionStrategy;
    #panelClass;
    #mouseEnterListener;
    #mouseLeaveListener;
    #clickListener;
    constructor(overlayPositionBuilder, elementRef, overlay, scrollDispatcher, renderer, injector) {
      this.overlayPositionBuilder = overlayPositionBuilder;
      this.elementRef = elementRef;
      this.overlay = overlay;
      this.scrollDispatcher = scrollDispatcher;
      this.renderer = renderer;
      this.injector = injector;
      this.ngxTooltip = input.required();
      this.tooltipPosition = input('bottom');
      this.disableArrow = input(false);
      this.tooltipType = input('click');
      this.closeTimeout = input();
      this.fitContent = input();
      this.#destroyed = new Subject();
      this.isShow = computed(() => !!this.ngxTooltip());
      this.tooltipTypeAction();
    }
    ngOnInit() {
      this.#positionStrategy = this.overlayPositionBuilder.flexibleConnectedTo(this.elementRef).withFlexibleDimensions(false).withViewportMargin(8).withPositions([this.getPosition(this.tooltipPosition()), ...this.getConnectionPositions()]).withPush(false);
      const scrollableAncestors = this.scrollDispatcher.getAncestorScrollContainers(this.elementRef);
      this.#positionStrategy.withScrollableContainers(scrollableAncestors);
      this.#positionStrategy.positionChanges.pipe(takeUntil(this.#destroyed)).subscribe(res => {
        this.#panelClass = res.connectionPair.panelClass;
      });
      this.#overlayRef = this.overlay.create({
        positionStrategy: this.#positionStrategy,
        scrollStrategy: this.overlay.scrollStrategies.close(),
        direction: 'rtl'
      });
      this.#panelClass = this.getPosition(this.tooltipPosition()).panelClass;
    }
    tooltipTypeAction() {
      effect(() => {
        const type = this.tooltipType();
        untracked(() => {
          switch (type) {
            case 'open':
              this.show();
              break;
            case 'close':
              this.hide();
              break;
            case 'hover':
              {
                this.#mouseEnterListener = this.renderer.listen(this.elementRef.nativeElement, 'mouseenter', this.show.bind(this));
                this.#mouseLeaveListener = this.renderer.listen(this.elementRef.nativeElement, 'mouseleave', this.hide.bind(this));
                break;
              }
            case 'click':
              {
                this.#clickListener = this.renderer.listen(this.elementRef.nativeElement, 'click', this.show.bind(this));
                this.#overlayRef._outsidePointerEvents.pipe(takeUntil(this.#destroyed)).subscribe(() => {
                  this.hide();
                });
                break;
              }
          }
        });
      }, {
        injector: this.injector
      });
    }
    show() {
      if (this.#overlayRef.hasAttached() || !this.isShow()) return;
      const tooltipComponentInjector = Injector.create({
        providers: [{
          provide: NgxTooltipToken,
          useValue: {
            panelClass: this.#panelClass
          }
        }]
      });
      const portal = new ComponentPortal(NgxTooltipComponent, null, tooltipComponentInjector);
      this.#tooltipRef = this.#overlayRef.attach(portal);
      this.#tooltipRef.setInput('disableArrow', this.disableArrow());
      this.#tooltipRef.setInput('fitContent', this.fitContent());
      if (this.ngxTooltip() instanceof TemplateRef) {
        this.#tooltipRef.setInput('template', this.ngxTooltip());
      } else {
        this.#tooltipRef.setInput('text', this.ngxTooltip());
      }
      this.tooltipValueAction();
      this.tooltipCloseTimeoutAction();
    }
    hide() {
      if (!this.#overlayRef.hasAttached()) return;
      this.#tooltipRef.instance.animationState.set('hidden');
      setTimeout(() => {
        this.#overlayRef.detach();
        this.tooltipValueActionEffect.destroy();
        this.tooltipCloseTimeoutActionEffect.destroy();
        clearTimeout(this.#withConditionTimeOut);
      }, 75);
    }
    tooltipValueAction() {
      this.tooltipValueActionEffect = effect(() => {
        const ngxTooltip = this.ngxTooltip();
        if (ngxTooltip) {
          if (ngxTooltip instanceof TemplateRef) {
            this.#tooltipRef.setInput('template', ngxTooltip);
          } else {
            this.#tooltipRef.setInput('text', ngxTooltip);
          }
        }
      }, {
        injector: this.injector,
        manualCleanup: true
      });
    }
    tooltipCloseTimeoutAction() {
      this.tooltipCloseTimeoutActionEffect = effect(() => {
        const closeTimeout = this.closeTimeout();
        if (closeTimeout) {
          this.#withConditionTimeOut = setTimeout(() => {
            untracked(() => {
              this.hide();
            });
          }, closeTimeout);
        }
      }, {
        injector: this.injector,
        manualCleanup: true
      });
    }
    getPosition(position = 'top') {
      switch (position) {
        case 'top':
          {
            return this.getConnectionPositions()[0];
          }
        case 'bottom':
          {
            return this.getConnectionPositions()[1];
          }
        case 'right':
          {
            return this.getConnectionPositions()[2];
          }
        case 'left':
          {
            return this.getConnectionPositions()[3];
          }
        case 'top-right':
          {
            return this.getConnectionPositions()[4];
          }
        case 'top-left':
          {
            return this.getConnectionPositions()[5];
          }
        case 'bottom-right':
          {
            return this.getConnectionPositions()[6];
          }
        case 'bottom-left':
          {
            return this.getConnectionPositions()[7];
          }
        default:
          return this.getPosition();
      }
    }
    getConnectionPositions() {
      return [{
        originX: 'center',
        originY: 'top',
        overlayX: 'center',
        overlayY: 'bottom',
        offsetY: -4,
        panelClass: 'tooltip-position-top'
      }, {
        originX: 'center',
        originY: 'bottom',
        overlayX: 'center',
        overlayY: 'top',
        offsetY: 4,
        panelClass: 'tooltip-position-bottom'
      }, {
        originX: 'start',
        originY: 'center',
        overlayX: 'end',
        overlayY: 'center',
        offsetX: 4,
        panelClass: 'tooltip-position-right'
      }, {
        originX: 'end',
        originY: 'center',
        overlayX: 'start',
        overlayY: 'center',
        offsetX: -4,
        panelClass: 'tooltip-position-left'
      }, {
        originX: 'center',
        originY: 'top',
        overlayX: 'end',
        overlayY: 'bottom',
        offsetY: -4,
        offsetX: -25,
        panelClass: 'tooltip-position-top-right'
      }, {
        originX: 'center',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'bottom',
        offsetY: -4,
        offsetX: 25,
        panelClass: 'tooltip-position-top-left'
      }, {
        originX: 'center',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top',
        offsetY: 4,
        offsetX: -25,
        panelClass: 'tooltip-position-bottom-right'
      }, {
        originX: 'center',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
        offsetY: 4,
        offsetX: 25,
        panelClass: 'tooltip-position-bottom-left'
      }];
    }
    ngOnDestroy() {
      this.#destroyed.next();
      this.#destroyed.complete();
      if (this.#mouseEnterListener) this.#mouseEnterListener();
      if (this.#mouseLeaveListener) this.#mouseLeaveListener();
      if (this.#clickListener) this.#clickListener();
      clearTimeout(this.#withConditionTimeOut);
    }
    static {
      this.ɵfac = function NgxTooltipDirective_Factory(t) {
        return new (t || NgxTooltipDirective)(i0.ɵɵdirectiveInject(i1.OverlayPositionBuilder), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.Overlay), i0.ɵɵdirectiveInject(i1.ScrollDispatcher), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.Injector));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgxTooltipDirective,
        selectors: [["", "ngxTooltip", ""]],
        inputs: {
          ngxTooltip: [i0.ɵɵInputFlags.SignalBased, "ngxTooltip"],
          tooltipPosition: [i0.ɵɵInputFlags.SignalBased, "tooltipPosition"],
          disableArrow: [i0.ɵɵInputFlags.SignalBased, "disableArrow"],
          tooltipType: [i0.ɵɵInputFlags.SignalBased, "tooltipType"],
          closeTimeout: [i0.ɵɵInputFlags.SignalBased, "closeTimeout"],
          fitContent: [i0.ɵɵInputFlags.SignalBased, "fitContent"]
        },
        standalone: true
      });
    }
  }
  return NgxTooltipDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-tooltip
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxTooltipDirective };
